import * as AIServiceSpeechRealtimeClient from "./ai-speech-realtime-web-client";
export * from "./ai-speech-realtime-web-client";
export * from "./ai-speech-api-client";
export default AIServiceSpeechRealtimeClient;
